module.exports = __webpack_public_path__ + "img/index_img7.6a2eec12.png";